module.exports = __webpack_public_path__ + "img/centEcnIslamic.ff226742.png";